// src/app/core/helpers/http-helper.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@environments/environment'; // Updated path alias
import { decodeHtmlEntities } from './utils/utils';

@Injectable({
  providedIn: 'root'
})
export class HttpHelperService {
  private baseUrl = environment.apiBaseUrl;
  private excludeDecoder:string[] = ['templates']

  private buildUrl(endpoint: string): string {
    const base = (this.baseUrl || '').replace(/\/+$/g, '');
    const path = (endpoint || '').replace(/^\/+/, '');
    const url = `${base}/${path}`;
    if (!base) {
      console.warn('[HttpHelperService] environment.apiBaseUrl is empty. Request will be relative:', url);
    }
    return url;
  }

  constructor(private http: HttpClient) { }

  get<T>(endpoint: string, params?: { [key: string]: any }): Observable<T> {
    const httpParams = this.buildParams(params);
    if (this.excludeDecoder.some(excluded => endpoint.includes(excluded))) {
      return this.http.get<T>(this.buildUrl(endpoint), { params: httpParams });
    }
    return this.http.get<T>(this.buildUrl(endpoint), { params: httpParams }).pipe(
      map((response: T) => this.decodeResponse(response))
    );
  }

  post<T>(endpoint: string, body: any): Observable<T> {
    return this.http.post<T>(this.buildUrl(endpoint), body);
  }

  put<T>(endpoint: string, body: any): Observable<T> {
    return this.http.put<T>(this.buildUrl(endpoint), body);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(this.buildUrl(endpoint));
  }
  downloadFile(url: string, params?: { [key: string]: any }): Observable<any> {
    const httpParams = this.buildParams(params);
    return this.http.get(this.buildUrl(url), { params: httpParams, responseType: 'blob' })
  }
  downloadFileResponse(
  url: string,
  method: 'get' | 'post' = 'get',
  body?: any
): Observable<HttpResponse<Blob>> {

  const options = {
    observe: 'response' as const,
    responseType: 'blob' as const
  };

  const request$ =
    method === 'post'
      ? this.http.post(this.buildUrl(url), body, options)
      : this.http.get(this.buildUrl(url), options);

  return request$ as Observable<HttpResponse<Blob>>;
}



  private buildParams(params?: { [key: string]: any }): HttpParams {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null) {
          httpParams = httpParams.set(key, params[key].toString());
        }
      });
    }
    return httpParams;
  }

  private decodeResponse(obj: any): any {
    if (typeof obj === 'string') return decodeHtmlEntities(obj);

    if (Array.isArray(obj)) {
      return obj.map(item => this.decodeResponse(item));
    }

    if (obj && typeof obj === 'object') {
      const decoded: any = {};
      for (const key of Object.keys(obj)) {
        decoded[key] = this.decodeResponse(obj[key]);
      }
      return decoded;
    }

    return obj;
  }


}